import React, { useState, useContext } from 'react';
import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import { makeStyles } from '@material-ui/core/styles';
import {
	LEARN_MORE_ANOMALY_TEXT,
	DEPARTMENT,
	CATEGORY,
	SUB_CATEGORY,
	ANOMALY_OVERVIEW,
	TOTAL,
	ANOMALY_OUTPERFORMING,
	ANOMALY_UNDERPERFORMING,
	INLINE,
	ALL,
	OUTPERFORMING,
	UNDERPERFORMING,
	GUIDED_INSIGHTS_HOME
} from '../../../constants/constant';
import { colors } from '../../../theme/color-palette';
import DefinitionDrawer from '../../../components/Definition/index';
import {
	// setTableColumns,
	// setTableRows,
} from '../../../redux/actions/anomalyDetectionActions';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ErrorScreen from '../ErrorScreen';
import { saveEventTrack } from '../../../redux/actions/eventTrackAction';
import { UserPortalContext } from '../../../context/appcontext';
import { updateTableRowsAndColumns, getAnomaliesSalesMetrics } from '../../../redux/actions/anomalyDetectionActions';

const AnomalyOverview = ({ setTabStates, handleAnomalyChange, startDate, endDate }) => {
	const dispatch = useDispatch();
	const portalUserContext = useContext(UserPortalContext);
	const useStyles = makeStyles(() => ({
		total: {
			fontFamily: 'Bogle-Regular',
			fontSize: '12px',
			lineHeight: '16px',
			marginTop: '5%',
		},
		tableHeader: {
			fontFamily: 'Bogle-Regular',
			fontSize: '14px',
			fontWeight: '700',
		},
		learnMore: {
			textAlign: 'end',
			marginRight: '3%',
			fontFamily: 'Bogle-Regular',
			fontSize: '14px',
			lineHeight: '20px',
			textDecorationLine: 'underline',
			color: colors.PURPLE_AI,
			cursor: 'pointer',
		},
		positive: {
			cursor: 'pointer',
			textDecorationLine: 'underline',
			color: `${colors.SUCCESS_MD} !important`,
		},
		negitive: {
			cursor: 'pointer',
			textDecorationLine: 'underline',
			color: `${colors.ERROR_MD} !important`,
		},
	}));

	const classes = useStyles();

	const initialCxt = {
		isDrawerOpened: false,
		metricType: null,
	};

	const [definition, setDefinition] = useState(initialCxt);

	const anomaly_summary = useSelector(
		(state) => state?.anomalyDetectionReducer
	);

	const chartData = useSelector(
		(state) => state?.anomalyDetectionReducer?.supplierShare
	);

	const {
		departmentTotal,
		departmentPositiveItems,
		departmentNegativeItems,
		categoryTotal,
		categoryPositiveItems,
		categoryNegativeItems,
		subcategoryTotal,
		subcategoryPositiveItems,
		subcategoryNegativeItems,
		categoryTableRows,
		subcategoryTableRows,
		departmentTableRows,
		deptAnomalies,
		catAnomalies,
		subCatAnomalies
	} = anomaly_summary;

	function createData(name, dept, cat, subcat) {
		return { name, dept, cat, subcat };
	}
	const rows = [
		createData(
			ANOMALY_OUTPERFORMING,
			departmentPositiveItems,
			categoryPositiveItems,
			subcategoryPositiveItems
		),
		createData(
			ANOMALY_UNDERPERFORMING,
			departmentNegativeItems,
			categoryNegativeItems,
			subcategoryNegativeItems
		),
		createData(
			INLINE,
			departmentTotal - (departmentPositiveItems + departmentNegativeItems),
			categoryTotal - (categoryPositiveItems + categoryNegativeItems),
			subcategoryTotal - (subcategoryPositiveItems + subcategoryNegativeItems)
		),
	];

	const handleLearnMore = () => {
		setDefinition({
			isDrawerOpened: true,
			metricType: 'anomaly',
		});
		const request = {
			event: 'Anomaly Definition Viewed',
			event_description: 'Anomalies Overview Table Selection: Learn More',
			attributes: GUIDED_INSIGHTS_HOME,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
	};

	const filterAnomaly = (anomaly) => {
		if(anomaly){
			if (anomaly === ANOMALY_UNDERPERFORMING) {
			handleAnomalyChange({
				target: {
					value: UNDERPERFORMING,
				},
			});
		} else if (anomaly === ANOMALY_OUTPERFORMING) {
			handleAnomalyChange({
				target: {
					value: OUTPERFORMING,
				},
			});
		} else {
			handleAnomalyChange({
				target: {
					value: ALL,
				},
			});
		}
		}
		
	};

	const handleCellClick = async (anomaly, view) => {
		window.scrollTo({
			left: 0,
			top: document.body.scrollHeight,
			behavior: 'smooth',
		});

		const obj = {
			startDate: startDate,
			endDate: endDate
		}
		if (view === CATEGORY) {
			await setTabStates([false, true, false]);
			if(categoryTableRows.length > 0) {
				dispatch(updateTableRowsAndColumns('CATEGORY'))
				filterAnomaly(anomaly);
			} else {
				dispatch(getAnomaliesSalesMetrics({
					attribute: 'CATEGORY',
					anomalies: catAnomalies,
					request: obj,
					anomaly: anomaly,
					filterAnomaly: filterAnomaly
				}))
			}
		} else if (view === SUB_CATEGORY) {
			await setTabStates([false, false, true]);
			if(subcategoryTableRows.length > 0) {
				dispatch(updateTableRowsAndColumns('SUBCATEGORY'))
				filterAnomaly(anomaly);
			} else {
				dispatch(getAnomaliesSalesMetrics({
					attribute: 'SUBCATEGORY',
					anomalies: subCatAnomalies,
					request: obj,
					anomaly: anomaly,
					filterAnomaly: filterAnomaly
				}))
			}
		} else {
			await setTabStates([true, false, false]);
			if(departmentTableRows.length > 0) {
				dispatch(updateTableRowsAndColumns('DEPARTMENT'))
				filterAnomaly(anomaly);
			} else {
				dispatch(getAnomaliesSalesMetrics({
					attribute: 'DEPARTMENT',
					anomalies: deptAnomalies,
					request: obj,
					anomaly: anomaly,
					filterAnomaly: filterAnomaly
				}))
			}
			
		}
	};

	return (
		<Box>
			{!anomaly_summary?.departmentTotal || !chartData?.details ? (
				<ErrorScreen
					chartTitle={ANOMALY_OVERVIEW}
					flag={chartData?.hierarchy_validation || 0}
				/>
			) : (
				<Box>
					<Box
						style={{
							fontFamily: 'Bogle-Regular',
							fontSize: '18px',
							fontStyle: 'normal',
							fontWeight: '400',
							lineHeight: '24px',
							marginTop: '2%',
							marginLeft: '2%',
							color: colors.DARK_GREY,
						}}>
						{ANOMALY_OVERVIEW}
					</Box>
					<Table
						sx={{
							width: '95%',
							marginLeft: '2%',
							marginTop: '5%',
							marginBottom: '3%',
						}}
						data-test-id={'ad-table'}
						aria-label="simple table">
						<TableHead
							sx={{ '&:first-child td, &:first-child th': { border: 0 } }}>
							<TableRow
								sx={{
									backgroundColor: colors.WHITE_GREY,
								}}>
								<TableCell></TableCell>
								<TableCell>
									<Box className={classes.tableHeader}>{DEPARTMENT}</Box>
									<Box
										className={classes.total}
										data-test-id="total department anomalies">
										<snap
											style={{
												marginRight: '3px',
											}}>
											{TOTAL}:
										</snap>
										{departmentTotal}
									</Box>
								</TableCell>
								<TableCell>
									<Box className={classes.tableHeader}>{CATEGORY}</Box>
									<Box
										className={classes.total}
										data-test-id="total category anomalies">
										<snap
											style={{
												marginRight: '3px',
											}}>
											{TOTAL}:
										</snap>
										{categoryTotal}
									</Box>
								</TableCell>
								<TableCell>
									<Box className={classes.tableHeader}>{SUB_CATEGORY}</Box>
									<Box
										className={classes.total}
										data-test-id="total subcategory anomalies">
										<snap
											style={{
												marginRight: '3px',
											}}>
											{TOTAL}:
										</snap>
										{subcategoryTotal}
									</Box>
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{rows?.map((row) => (
								<TableRow key={row.name}>
									<TableCell
										component="th"
										scope="row"
										sx={{
											fontFamily: 'Bogle-Regular',
											fontSize: '14px',
											fontWeight: '700',
										}}>
										{row.name}
									</TableCell>
									<TableCell
										onClick={() => handleCellClick(row.name, DEPARTMENT)}
										className={`${
											row.name === INLINE || row.dept <= 0
												? null
												: row.name === ANOMALY_OUTPERFORMING
												? classes.positive
												: classes.negitive
										}`}>
										{row.dept > 0 ? row.dept : '-'}
									</TableCell>
									<TableCell
										onClick={() => handleCellClick(row.name, CATEGORY)}
										className={`${
											row.name === INLINE || row.cat <= 0
												? null
												: row.name === ANOMALY_OUTPERFORMING
												? classes.positive
												: classes.negitive
										}`}>
										{row.cat > 0 ? row?.cat : '-'}
									</TableCell>
									<TableCell
										onClick={() => handleCellClick(row.name, SUB_CATEGORY)}
										className={`${
											row.name === INLINE || row?.subcat <= 0
												? null
												: row.name === ANOMALY_OUTPERFORMING
												? classes.positive
												: classes.negitive
										}`}>
										{row.subcat > 0 ? row?.subcat : '-'}
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
					<Box
						data-test-id={'learn-more'}
						className={classes.learnMore}
						onClick={handleLearnMore}>
						{LEARN_MORE_ANOMALY_TEXT}
					</Box>
				</Box>
			)}
			<DefinitionDrawer
				isOpen={definition.isDrawerOpened}
				metricType={definition.metricType}
				onClose={() => setDefinition(initialCxt)}
			/>
		</Box>
	);
};

AnomalyOverview.propTypes = {
	setTabStates: PropTypes.func,
	handleAnomalyChange: PropTypes.func,
	startDate: PropTypes.string,
	endDate: PropTypes.string
};

export default AnomalyOverview;
